import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarChart from '../common/Charts/BarChart';
import { processData, IMAGES, checkAsterickFormate } from '../../util/QuickReportsUtils';
import * as messages from './../../messages/ReportsMessages';
import { MODULE_SIMULTANEOUS_USAGE } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

export default class SimultaneousUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'Percent',
      selectedDropdown: 'Often',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  componentDidMount() {
    this.props.handletitle('Simultaneous Usage: While Watching TV');
    this.props.handleExportParams(
      this.state.selectedRadioButton,
      this.state.selectedDropdown,
      undefined,
    );
    this.props.trackerFn({ subModule: MODULE_SIMULTANEOUS_USAGE });
  }

  UNSAFE_componentWillReceiveProps() {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }
  handleDropdownChange = e => {
    this.setState({ selectedDropdown: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        this.state.selectedDropdown,
        undefined,
      );
    });
  };

  handleRadioButtonChange = e =>
    this.setState({ selectedRadioButton: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        this.state.selectedDropdown,
        undefined,
      );
    });

  calculateAsterisk = sample => {
    // if(sample)
    //  console.log(" Sample data  val "+ JSON.stringify(sample));
    if (this.state.showSingleAsterisk || this.state.showSingleAsterisk) {
      if (sample < 31) {
        return '**';
      }
      if (sample < 61) {
        return '*';
      }
    }

    return '';
  };

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  renderDropdown = () =>
    Object.keys(this.props.data).map(item => (
      <option value={item} key={uuid()}>
        {item}
      </option>
    ));

  render() {
    return (
      <div className="quick-report-graph-wrapper">
        <div className="large-12 text-center margin-top-10 margin-bottom-10">
          <div className="quick-report-dropdown display-inline">
            <select
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdown}
            >
              {this.renderDropdown()}
            </select>
          </div>
          <div className="quick-report-radio display-inline">
            <p>
              <input
                type="radio"
                id="percentType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Percent'}
                onChange={this.handleRadioButtonChange}
                value="Percent"
              />
              <label htmlFor="percentType">
                <span>Percent</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="indexType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Index'}
                onChange={this.handleRadioButtonChange}
                value="Index"
              />
              <label htmlFor="indexType">
                <span>Index</span>
              </label>
            </p>
          </div>
        </div>
        <div className="column large-12">
          <BarChart
            chartColor={chartColor}
            data={{
              processedData: processData(
                {
                  rawData: this.props.data[this.state.selectedDropdown],
                  y:
                    this.state.selectedRadioButton === 'Percent'
                      ? 'pct'
                      : 'index',
                  colorValue:
                    this.state.selectedRadioButton === 'Percent'
                      ? undefined
                      : 100,
                  maxColor: '#247BA0',
                  minColor: '#F25F5C',
                },
                this.updateAsteriskStatus,
                this.props.study,
              ),
              tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
            }}
            plotLines={[
              {
                color: '#30435d',
                value: 100,
                width: 2,
              },
            ]}
            dataLabelFormat={
              this.state.selectedRadioButton === 'Percent'
                ? checkAsterickFormate(
                    '{y}%',
                    this.state.showDoubleAsterisk,
                    this.state.showSingleAsterisk,
                  )
                : checkAsterickFormate(
                    '{y}',
                    this.state.showDoubleAsterisk,
                    this.state.showSingleAsterisk,
                  )
            }
            yLabel={
              this.state.selectedRadioButton === 'Percent'
                ? '{value}%'
                : '{value}'
            }
            xAxisLabelDistance={-20}
            chartType={'bar'}
            formaterVal={this.calculateAsterisk(this.y) + this.y}
            dataLabels
            xLabelPadding={30}
            labelFormatter={{
              'Watch Videos on Computer': `<p>Watch Videos on Computer: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_stream_video
              } /></p>`,
              'Visit Websites on Mobile Phone': `<p>Visit Websites on Mobile Phone: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_browser
              } /></p>`,
              'Visit Websites on Computer': `<p>Visit Websites on Computer: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_browser
              } /></p>`,
              'Text on Mobile Phone': `<p>Text on Mobile Phone: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_text_message
              } /></p>`,
              'Talk on Mobile Phone': `<p>Talk on Mobile Phone: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_talk
              } /></p>`,
              'Read Magazine/Comic': `<p>Read Magazine/Comic: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_magazine
              } /></p>`,
              'Play Games': `<p>Play Games: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_gaming_console
              } /></p>`,
              'Listen to Radio': `<p>Listen to Radio: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_radio
              } /></p>`,
              'IM/Chat on Computer': `<p>IM/Chat on Computer: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_chat
              } /></p>`,
              'Email on Computer': `<p>Email on Computer: <img width="40px" class="display-inline" src=${
                IMAGES.ICON_email
              } /></p>`,
            }}
          />
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

SimultaneousUsage.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
